'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactElement, ReactNode } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '#ui/dialog';
import { buildDangerButtonClassName } from './build-danger-button-class-name';
import { HStack } from './h-stack';
import { VStack } from './v-stack';
type ConfirmDialogProps = {
  open: boolean;
  title: string;
  description: ReactNode;
  confirmLabel: string;
  busyLabel?: string;
  busy?: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
};

/** A destructive-action confirmation dialog with a Cancel/confirm button pair; `busy` disables both and swaps the confirm label. */
export const ConfirmDialog = t0 => {
  const $ = _c(27);
  const {
    open,
    title,
    description,
    confirmLabel,
    busyLabel,
    busy: t1,
    onConfirm,
    onOpenChange
  } = t0;
  const busy = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== title) {
    t2 = <DialogTitle className="text-[22px] tracking-tight">{title}</DialogTitle>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== description) {
    t3 = <DialogDescription className="text-[15px] leading-[22px]">{description}</DialogDescription>;
    $[2] = description;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <VStack gap={2}>{t2}{t3}</VStack>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onOpenChange) {
    t5 = () => onOpenChange(false);
    $[7] = onOpenChange;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== busy || $[10] !== t5) {
    t6 = <button type="button" onClick={t5} disabled={busy} className="px-5 py-2.5 rounded-full border border-border text-sm font-semibold text-fg hover:bg-surface-muted transition-colors disabled:opacity-50">Cancel</button>;
    $[9] = busy;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = buildDangerButtonClassName();
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = busy ? busyLabel ?? confirmLabel : confirmLabel;
  let t9;
  if ($[13] !== busy || $[14] !== onConfirm || $[15] !== t8) {
    t9 = <button type="button" onClick={onConfirm} disabled={busy} className={t7}>{t8}</button>;
    $[13] = busy;
    $[14] = onConfirm;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t9) {
    t10 = <HStack gap={3} justify="end">{t6}{t9}</HStack>;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t4) {
    t11 = <DialogContent showClose={true} className="max-w-100 flex flex-col gap-6 p-8">{t4}{t10}</DialogContent>;
    $[20] = t10;
    $[21] = t4;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== onOpenChange || $[24] !== open || $[25] !== t11) {
    t12 = <Dialog open={open} onOpenChange={onOpenChange}>{t11}</Dialog>;
    $[23] = onOpenChange;
    $[24] = open;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};